<template>
  <v-app d="inspire">
    <v-app-bar color="deep-purple" dark max-height="64">
      <v-app-bar-nav-icon @click="drawer = true"></v-app-bar-nav-icon>
      <v-toolbar-title>Just Learning App</v-toolbar-title>
    </v-app-bar>

    <v-navigation-drawer v-model="drawer" absolute temporary>
      <v-list nav dense>
        <v-list-item-group
          v-model="group"
          active-class="deep-purple--text text--accent-4"
        >
          <v-list-item :to="{ name: 'Games' }">
            <v-list-item-icon>
              <v-icon>mdi-home</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Games</v-list-item-title>
          </v-list-item>
          <v-list-item :to="{ name: 'StateTrivia' }">
            <v-list-item-icon>
              <v-icon>mdi-controller-classic</v-icon>
            </v-list-item-icon>
            <v-list-item-title>State Trivia</v-list-item-title>
          </v-list-item>
          <v-list-item :to="{ name: 'About' }">
            <v-list-item-icon>
              <v-icon>mdi-information</v-icon>
            </v-list-item-icon>
            <v-list-item-title>About</v-list-item-title>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>
    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>


<script>
export default {
  mounted() {
    // todo : check to see if i should move this somewhere else
    let urlConfig = this.$route.query.config;
    if (urlConfig) {
      urlConfig = atob(urlConfig);
      urlConfig = JSON.parse(urlConfig);
    }
    const fileConfig = require("@/assets/config.json");
    const config = (urlConfig || fileConfig).config;

    this.$store.dispatch("options/initialize", config);
  },
  data: () => ({
    drawer: false,
    group: null,
  }),
};
</script>
